import projects from '../content/projects/projects.json'

export default function useProjects(projectCategoryId) {
    if (!projectCategoryId) {
        return projects
    }

    return projects.filter((x) => x.categoryId === projectCategoryId)
}
